/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-15 17:28:17
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getOemlist
   * @description 查看OEM列表
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  getOemlist(data) {
    return request.get(`${BASE_URL}/oem/list`, data)
  },

  /**
   * createOem
   * @description 创建OEM商户
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  createOem(data) {
    return request.post(`${BASE_URL}/oem/create`, data)
  },

  /**
   * alterStatus
   * @description 禁用启用按钮
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  alterStatus(id, data) {
    return request.put(`${BASE_URL}/oem/alter_status/${id}`, data)
  },

  /**
   * deleteOem
   * @description 删除按钮
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  deleteOem(id) {
    return request.Delete(`${BASE_URL}/oem/delete/${id}`)
  },

  /**
   * updateOem
   * @description 修改OEM信息
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  updateOem(id, data) {
    return request.put(`${BASE_URL}/oem/update/${id}`, data)
  },

   /**
   * updateOem
   * @description  OEM商户审核
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  oemAudit(id, data){
    return request.put(`${BASE_URL}/oem/audit/${id}`, data)
  }
}